import moment from 'moment'


export const helper = {
    delElementInArr: (el, arr)=>deleteElementInArray(el, arr),
    delElementInString: (element, string)=>deleteElementInString(element,string),
    getRoleName: (role)=>getRoleName(role)
}


export const deleteElementInArray = (element, array) => {
   const indexToDelete = array.indexOf(element)
   array.splice(indexToDelete, 1)
   return array
}

export const deleteElementInString = (element, string) => {
    const stringArr = string.split(',')
    if(stringArr.length===1)return null
    const index = stringArr.indexOf(element)
    stringArr.splice(index, 1)
    const outputString= stringArr.join(',')
    return outputString
}

export const getRoleName = (role) =>{
    switch (role) {
        case 'canidate':
            return 'Helfer & Hilfesuchender'
        case 'requester':
            return 'Hilfesuchender'
        case 'admin':
            return 'Administrator'
        default:
            return null;
    }
}

export const getDateFormated = (date, type) => {
    switch (type) {
        case 'withWeekDay':
        return moment(date).format('dddd DD.MM.YYYY')

        case 'normal':
        return moment(date || date).format('DD.MM.YYYY')

        case 'untilThen':
        return moment(date, "YYYY-MM-DD").fromNow()

        case 'timeStamp' :
        return moment().format()

        case 'withTime' :
        return moment(date).format('lll')
    
        default:
            return moment(date || date).format('YYYY-MM-DD');
    }
}

export const passwordGenerator = () => {
        const arrMax = 10
        const typoMax = 5
        const partsArr = ['Sommer', 'Winter', 'Herbst', 'Regen', 'Sonne', 'Nebel', 'Wolke', 'Freude', 'Hilfe', 'Helfen']
        const typo = '-_%$?'
        const arrRandom = Math.floor(Math.random() * Math.floor(arrMax));
        const typoRandom = Math.floor(Math.random() * Math.floor(typoMax));
        const partOne = partsArr[arrRandom]
        const partTwo = typo.charAt(typoRandom)
        const partThree = Math.floor(Math.random() * Math.floor(9))
        const partFour = Math.floor(Math.random() * Math.floor(9))
        const password = partOne + partTwo + partThree + partFour
        return password
}



// WEBPACK FOOTER //
// ./src/js/helper.js